<template>
  <div
    class="coupon-item j-select-coupon-item"
    @click="updateActiveCouponId"
    :pointValue="
      fullReductType ? fullReductMoney + currency : discount + '%OFF'
    "
    v-if="!isEmpty"
    :class="{ active: active, invalid: invalid }"
  >
    <div class="left">
      <div class="coupon-item-sign" :style="getCouponBgImg">
        <div v-if="fullReductType" class="coupon-item-value flex-center">
          <p>{{ fullReductMoney }}</p>
          <p class="coupon-item-unit">{{ currency }}</p>
        </div>
        <div v-else class="coupon-item-value flex-center">
          <p>{{ discount }} %</p>
          <p class="coupon-item-unit">OFF</p>
        </div>
      </div>
    </div>
    <div class="right">
      <p class="coupon-item-tag">{{ tagText }}</p>
      <p class="coupon-item-tip">{{ localStartDate }} - {{ localEndDate }}</p>
      <div>
        <span class="coupon-item-tip" v-if="fullReductLimitBottomMoney === 0">
          {{ letter.couponNoLimit }}
        </span>
        <span class="coupon-item-tip" v-if="fullReductLimitBottomMoney > 0">
          {{
            letter.couponFuilCanUse
              .replace('${price}', fullReductLimitBottomMoney)
              .replace('${currency}', currency)
          }}
        </span>
        <span class="coupon-item-tip">
          {{
            letter.voucherLimitRegion
              ? letter.voucherLimitRegion.replaceAll('${currency}', currency)
              : ''
          }}
        </span>
        <span class="coupon-item-tip">{{ useLimitTip }}</span>
      </div>
      <p class="coupon-item-tip" v-if="discountType && discountLimitTopMoney">
        ({{
          letter.couponMaxDiscount
            .replace('${price}', discountLimitTopMoney)
            .replace('${currency}', currency)
        }})
      </p>
      <p class="coupon-item-tip high-light" v-if="hasUsed">
        {{ letter.couponHasUsed }}：{{ localUsedDate }}
      </p>
      <div v-if="!invalid" class="coupon-item-btn">
        <Icon
          class="checked-ico"
          :class="{
            checked: active
          }"
          :name="active ? 'checked' : 'round'"
        ></Icon>
      </div>
    </div>
  </div>
  <div class="empty" :class="{ invalid: invalid }" v-else>
    <div class="no-coupon-icon"></div>
    <p class="empty-text">{{ letter.voucherLiuyi }}</p>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import coupon from '@mixins/officialTopup/coupon';
import { times, couponLocalDateFormat } from '@utiles/officialStore';
export default {
  name: 'couponItem',
  props: ['info', 'active', 'invalid', 'isEmpty'],
  mixins: [coupon],
  data() {
    return {
      chooseCouponId: ''
    };
  },
  computed: {
    ...mapState({
      picList: state => state.page.picList
    }),
    fullReductType() {
      return +this.info.TYPE === 0;
    },
    discountType() {
      return +this.info.TYPE === 1;
    },
    startDate() {
      return this.dateFormat(this.info.START_TIME);
    },
    endDate() {
      return this.dateFormat(this.info.EXPIRY_TIME);
    },
    lang() {
      return this.$store.state.lang;
    },
    localGetDate() {
      return couponLocalDateFormat(this.info.GET_TIME, this.lang);
    },
    localStartDate() {
      return couponLocalDateFormat(this.info.START_TIME, this.lang);
    },
    localEndDate() {
      return couponLocalDateFormat(this.info.EXPIRY_TIME, this.lang);
    },
    localUsedDate() {
      return couponLocalDateFormat(this.info.USE_TIME, this.lang);
    },
    currency() {
      return this.info?.CURRENCY || '';
    },
    fullReductLimitBottomMoney() {
      return +this.info.LIMIT_BOTTOM_MONEY || 0;
    },
    fullReductMoney() {
      return this.info.REDUCTION_MONEY || 0;
    },
    discount() {
      return times(+this.info.DISCOUNT, 100);
    },
    discountLimitTopMoney() {
      return +this.info.LIMIT_TOP_MONEY;
    },
    useLimitTip() {
      let tips = [];
      const productType = {
        coin: this.letter.couponOnlyCoinCanUse,
        package: this.letter.couponOnlyPackageCanUse,
        subscription: this.letter.couponOnlySubCanUse,
        currency: this.letter.couponOnlyDaibiCanUse
      };
      const hasPaytypeList =
        (this.info.PAY_TYPE_LIST && this.info.PAY_TYPE_LIST.length) || 0;
      const hasProductList =
        (this.info.PRODUCT_LIST && this.info.PRODUCT_LIST.length) || 0;
      const hasProductType = this.info.PRODUCT_TYPE || 0;

      if (hasProductType) {
        tips.push(productType[this.info.PRODUCT_TYPE]);
      }

      if (hasPaytypeList && hasProductList) {
        tips.push(this.letter.couponPartProductCanUse);
        tips.push(this.letter.couponPartPaytypeCanUse);
      } else if (hasPaytypeList && !hasProductList) {
        tips.push(this.letter.couponPartPaytypeCanUse);
      } else if (!hasPaytypeList && hasProductList) {
        tips.push(this.letter.couponPartProductCanUse);
      } else if (!hasPaytypeList && !hasProductList && !hasProductType) {
        tips.push(this.letter.couponAllProductCanUse);
      }

      return tips.join(';');
    },
    letter() {
      return this.$store.state.letter;
    },
    tagText() {
      if (this.info.DESCRIPTION) {
        return this.info.DESCRIPTION;
      }
      if (this.fullReductType) {
        return this.letter.couponReductionType;
      }
      if (this.discountType) {
        return this.letter.couponDiscountType;
      }
      return '';
    },
    hasUsed() {
      // -1 提单未支付 0 未使用 1 完成支付 2 回收
      return +this.info.STATE === 1 || +this.info.STATE === -1;
    },
    getCouponBgImg() {
      const key = this.fullReductType ? 'rcoupon' : 'dcoupon';
      if (this.picList?.[key]) {
        return {
          background: `url(${this.picList?.[key]}) no-repeat center center`,
          backgroundSize: '100% 100%'
        };
      } else {
        return {};
      }
    }
  },
  methods: {
    dateFormat(time) {
      const t = new Date(+time * 1000);
      const formate = 'Y-M-D h:m';
      let year = t.getFullYear();
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hour = t.getHours();
      let minu = t.getMinutes();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      minu = minu == 0 ? '00' : minu;
      const hash = {
        Y: year,
        M: month,
        D: day,
        h: hour,
        m: minu
      };
      return formate.replace(/\w/g, i => {
        return hash[i];
      });
    },
    updateActiveCouponId() {
      window.webstorev3DataLayer.push({
        eventName: 'select_coupon',
        eventReason: 'click_select',
        eventValue: {
          coupon_typeid: this.info?.COUPON_TYPE || '',
          coupon_type_name: this.tagText || '',
          coupon_id: this.info?.COUPON_ID || '',
          coupon_start_time: this.info?.GET_TIME || '',
          coupon_end_time: this.info?.EXPIRY_TIME || '',
          coupon_local_money: this?.fullReductMoney || '',
          coupon_discount: this.info?.DISCOUNT || ''
        }
      });
      this.$emit('chooseCoupon', this.info.COUPON_ID);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopup/_dimen.scss';
.coupon-item {
  display: flex;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;
  font-size: 20px;
  color: #999999;
  line-height: 1.2;
  margin-bottom: 30px;
  width: 100%;
  padding: 20px;
  border-radius: 20px;
  background: #ffffff;
  cursor: pointer;
  .left {
    flex-shrink: 0;
    color: #333333;
    width: 99px;
    height: 96px;
  }
  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    margin-left: 20px;
    padding-right: 60px;
    flex: 1;
  }
  &-sign {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &-choose-ico {
    position: absolute;
    right: 5px;
    bottom: 3px;
    font-size: 40px;
    color: #fff;
  }
  &-value {
    font-size: 30px;
    text-align: center;
    font-weight: bold;
    flex-direction: column;
  }
  &-unit {
    font-size: 20px;
    text-align: center;
  }
  &-tag {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
  }
  &-tip {
    line-height: 1.5;
    color: #999;

    &.high-light {
      width: fit-content;
      background-color: #333333;
      color: #ffffff;
      border-radius: 3px;
      padding: 0 10px;
    }
  }
  &-btn {
    position: absolute;
    right: 0;
    .checked-ico {
      width: 38px;
      height: 38px;
      color: #333333;
      &.checked {
        color: $themeColor;
        border-radius: 50%;
      }
    }
  }

  &.active {
    border: 3px solid $borderColor;
  }
  &.invalid {
    .coupon-item-use {
      background-image: linear-gradient(to right, #eae1d8, #bcb3a8);
    }
  }
}
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 325px;
  .no-coupon-icon {
    margin-right: 10px;
    flex-shrink: 0;
    width: 100px;
    height: 100px;
    background: url($commonImg + 'no-coupon.png') no-repeat;
    background-size: 100% 100%;
  }
  .empty-text {
    font-size: 24px;
    color: #333333;
    text-align: center;
  }
}
@media screen and (orientation: landscape) {
  .coupon-item {
    font-size: 16px;
    margin-bottom: 10px;
    &-tag {
      font-size: 18px;
    }
    &-type {
      font-size: 16px;
    }
    &-tip {
      font-size: 16px;
    }
    &-value {
      font-size: 23px;
    }
    &-unit {
      font-size: 16px;
    }
    &-btn {
      .checked-ico {
        width: 24px;
        height: 24px;
      }
    }
    .left {
      width: 76px;
      height: 76px;
    }
  }
}
</style>
